import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M12 20v-2m0-2v-1.5c0-1 1.42-1.844 2.009-2.195C15.159 11.62 16 10.435 16 9c0-2.17-1.83-4-4-4S8 6.83 8 9"
      stroke={color}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round"
    />
  </svg>
);
